/* eslint-disable quote-props */
import { Injectable } from '@angular/core';
import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONTENTFUL } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {
  constructor() { }

  private client = contentful.createClient({
    space: CONTENTFUL.spaceId,
    accessToken: CONTENTFUL.token,
    environment: CONTENTFUL.environment
  });
  public options = {
    renderNode: {
      [INLINES.HYPERLINK]: (node) => {
        return `<a target="_blank" rel="noreferrer" href="${node.data.uri}">${node.content[0].value}</a>`;
      },
      'embedded-asset-block': (node) => {
        const file = node.data.target.fields.file;
        const renderedMedia = this.renderMedia(file);
        return renderedMedia;
      },
      [BLOCKS.PARAGRAPH]: (node, next) => `<p>${next(node.content).replace(/\n/g, '<br/>')}</p>`,
    },
  };

  public getField(contentId): Observable<any> {

    const promise = this.client.getEntry(contentId);
    return from(promise)
      .pipe(
        map(entry => entry.fields)
      );
  }
  public getContent(contentId, order?: string): Observable<any> {
    const p = this.client.getEntries({ content_type: contentId, limit: 300, order });
    return from(p)
      .pipe(
        map(entry => entry.items)
      );
  }
  public getContentByCarrierId(contentId, carrierId): Observable<any> {
    const p = this.client.getEntries({
      'fields.carrierId': carrierId,
      'content_type': contentId
    });
    return from(p)
      .pipe(
        map(entry => entry.items)
      );
  }
  public getQuestionsByCategoryId(contentId, categoryId): Observable<any> {
    const p = this.client.getEntries({
      'fields.categoryId': categoryId,
      'content_type': contentId
    });
    return from(p)
      .pipe(
        map(entry => entry.items)
      );
  }
  public renderMedia(file): string {
    if (file.contentType === 'video/mp4') {
      return (
        `<video width:200px; height:100px; controls>
            <source src=${file.url} type='video/mp4'/>
            <p>Your browser doesnt support HTML5 video.</p>
          </video>`
      );
    } else if (file.contentType === 'image/jpeg' || file.contentType === 'image/png' ||
      file.contentType === 'image/gif' || file.contentType === 'image/svg+xml') {
      return (`<img class="promise__img-three" src=${file.url} /> `);
    }
    else if (file.contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.contentType === 'application/msword' || file.contentType === 'application/vnd.ms-powerpoint') {
      return (
        ` <img class="download-icon" src="/assets/icon/Download-icon.svg" alt="download link icon"><a href="${file.url}" download="g2g-files"> Download additional info. </a><br>`
      );
    }
    else if (file.contentType === 'application/pdf') {
      return (
        ` <img class="download-icon" src="/assets/icon/Download-icon.svg"
       alt="download link icon"><a href="${file.url}" target="_blank" rel="noreferrer" download="g2g-files"> Download additional info. </a><br>`
      );
    }
  }
  public getRichText(contentId, answerId): any {
    this.client
      .getEntries({
        'fields.answerId': answerId,
        'content_type': contentId
      })
      .then(entry => {
        const rawRichTextField = entry.items[0].fields;
        // eslint-disable-next-line @typescript-eslint/dot-notation
        return documentToHtmlString(rawRichTextField['answerText'], this.options);
      })
      .then(renderedHtml => {
        document.getElementById(answerId).innerHTML = renderedHtml;
      })
      .catch(error => console.error(error));
  }
  public getAnswerIdByQstId(contentId, qstId): Observable<any> {
    const p = this.client.getEntries({
      'fields.questionId': qstId,
      'content_type': contentId
    });
    return from(p)
      .pipe(
        map(entry => entry.items[0].fields)
      );
  }
  public getTestimonialsByPageId(contentId, pageId): Observable<any> {
    const p = this.client.getEntries({
      'fields.testimonialsPageId': pageId,
      content_type: contentId
    });
    return from(p)
      .pipe(
        map(entry => entry.items)
      );
  }

  public getInternationalCallingContentByCategory(contentId, limit, catgeory, locale?): Observable<any> {
    const p = this.client.getEntries({
      'fields.categoryId': catgeory,
      include: 2,
      limit,
      content_type: contentId,
      locale
    });
    return from(p)
      .pipe(
        map(entry => entry.items)
      );
  }

   public getRichTextWithOptions(richText): any {
    return documentToHtmlString(richText, this.options);
  }
}
